module.exports = __webpack_public_path__ + "img/901496778.ed574d07.png";